import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ICapturistaListRequest, ICapturistaListResponse, ICapturistaDeleteRequest, ICapturistaDeleteResponse, IUsuarioDropdownRequest, IUsuarioDropdownResponse, ICapturistaAddRequest, ICapturistaAddResponse, ICapturistaDetailRequest, ICapturistaDetailResponse, ICapturistaUpdateRequest, ICapturistaUpdateResponse } from '../interfaces/capturistas.interface';

@Injectable({
  providedIn: 'root'
})
export class CapturistasService {

  constructor(private http: HttpClient) { }


  getCapturistasList(payload: ICapturistaListRequest): Observable<ICapturistaListResponse> {
    return this.http.post<ICapturistaListResponse>(`${environment.apiNewBackBaseUrl}Capturistas/cmspa_CapturiList`, payload);
  }
  
  deleteCapturista(clave_capturista: string): Observable<ICapturistaDeleteResponse> {
    const payload: ICapturistaDeleteRequest = {
      que: 3,
      tope: '',
      cmd: '',
      clave_capturista,
      nombre: ''
    };
    return this.http.post<ICapturistaDeleteResponse>(`${environment.apiNewBackBaseUrl}Capturistas/cmspa_CapturiDelete`, payload);
  }

  getUsuariosDropdown(payload: IUsuarioDropdownRequest): Observable<IUsuarioDropdownResponse> {
    return this.http.post<IUsuarioDropdownResponse>(`${environment.apiNewBackBaseUrl}UsuarsCS/Getcmspa_usua4V2`, payload);
  }

  addCapturista(payload: ICapturistaAddRequest): Observable<ICapturistaAddResponse> {
    return this.http.post<ICapturistaAddResponse>(`${environment.apiNewBackBaseUrl}Capturistas/cmspa_CapturiAdd`, payload);
  }

  getCapturistaDetail(payload: ICapturistaDetailRequest): Observable<ICapturistaDetailResponse> {
    return this.http.post<ICapturistaDetailResponse>(`${environment.apiNewBackBaseUrl}Capturistas/cmspa_CapturiListDet`, payload);
  }

  updateCapturista(payload: ICapturistaUpdateRequest): Observable<ICapturistaUpdateResponse> {
    return this.http.post<ICapturistaUpdateResponse>(`${environment.apiNewBackBaseUrl}Capturistas/cmspa_CapturiUpd`, payload);
  }
} 